import React from "react";
import { selectFormat } from "./../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayLineChartTooltip = (props) => {
  const { data, close } = props;
  const extra = data.extra ? data.extra : null;

  if (extra !== null) {
    return (
      <div>
        <XRayTooltipHeader date={data.activeLabel} close={close} />

        <main className="standard-tooltip__main">
          {data.indicator === "freeTrialStarts" ? (
            <>
              <div className="standard-tooltip__item">
                <span className="standard-tooltip__key">
                  <span
                    className="standard-tooltip__icon"
                    style={{ background: "#fc6d52" }}
                  />
                  {data.renderLabel}
                </span>
                <span className="standard-tooltip__value">
                  {selectFormat("number", extra.current_value)}
                </span>
              </div>

              <div className="standard-tooltip__item">
                <span className="standard-tooltip__key">
                  <span
                    className="standard-tooltip__icon"
                    style={{
                      background: "#fc6d52",
                      opacity: 0.2,
                    }}
                  />
                  {data.formattedText}
                </span>
                <span className="standard-tooltip__value">
                  {selectFormat("number", extra.previous_value)}
                </span>
              </div>
            </>
          ) : (
            <>
              {Object.keys(data.activePayload)
                .sort(
                  (a, b) =>
                    data.activePayload[b].value - data.activePayload[a].value
                )
                .filter((key) => data.activePayload[key].value > 0)
                .map((key, index) => {
                  return (
                    <div className="standard-tooltip__item" key={key}>
                      <span
                        className="standard-tooltip__icon"
                        // set the background color according the chart name
                        style={{
                          background:
                            data.extra[data.activePayload[key].name].color ||
                            data.activePayload[key].color,
                        }}
                      />
                      <span className="standard-tooltip__key">
                        {data.extra[data.activePayload[key].name].label}
                      </span>
                      <span className="standard-tooltip__value">
                        {selectFormat("number", data.activePayload[key].value)}
                      </span>
                    </div>
                  );
                })}
            </>
          )}
        </main>
      </div>
    );
  } else {
    return null;
  }
};
